import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Suppress benign "ResizeObserver loop" warnings that otherwise trip the dev error overlay.
const _onerror = window.onerror;
window.onerror = (msg, ...rest) =>
  /ResizeObserver loop/.test(String(msg)) ? true : (_onerror ? _onerror(msg, ...rest) : false);
window.addEventListener("error", (e) => {
  if (e?.message && /ResizeObserver loop/.test(e.message)) {
    e.stopImmediatePropagation();
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
